export default __webpack_public_path__ + "static/media/textShadeMiiClip.fb0fec45.mp4";